import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Props from './ContinueCheckoutBannerComponent';
import SelectLanguage from './SelectLanguage';
import { createPortal } from 'react-dom';
import clsx from 'clsx';

const tabletBreakpoint = '768';

class ContinueCheckoutBanner extends Component<Props> {
    cartPlaceholder = null;

    state = {
      parentScreenWidth: window?.parent?.innerWidth,
    };

    onWindowResize = () => {
      this.setState({
        parentScreenWidth: window?.parent?.innerWidth,
      });
    };

    componentDidMount() {
      if (this.props.isDynamicListing) {
        window?.parent.addEventListener('resize', this.onWindowResize);
      }

      if (window.frameElement && window.parent) {
        this.cartPlaceholder = window.parent.document.querySelector('.cart-pill__placeholder');
      }
    }

    componentWillUnmount() {
      window?.parent.removeEventListener('resize', this.onWindowResize);
    }

    shouldShow = () => {
      if (this.props.isDynamicListing) {
        return true;
      }
      return this.props.showCartPill && (this.props.itemCount > 0 || this.props.forceShow);
    }

    renderContent = () => {
      let pillClass = 'checkout__cart-pill';
      if (this.props.isDynamicListing) {
        pillClass += ' checkout__cart-pill-dynamic-listing';
      }

      const mainClassName = this.props.isDynamicListing && this.state?.parentScreenWidth >= tabletBreakpoint
        ? 'checkout__bar checkout__bar--with-margin'
        : 'checkout__bar';
      
      return (
        <div className={clsx(mainClassName, this.cartPlaceholder && this.props.pinToBottom && 'checkout__bar--bottom')}>
          <SelectLanguage className='select-language--listing' />
          {this.shouldShow() && (
            <button className={pillClass} onClick={this.props.showCart} disabled={!this.props.reservationActive}>
              {this.props.timeRemaining !== '00:00' &&
                <span className="checkout__cart-pill__timer">
                  <i className="icon-clock" />
                  <span className="checkout__cart-pill__timer-time" aria-live='polite'>
                    {this.props.timeRemaining}
                  </span>
                </span>
              }
              <span className="checkout__cart-pill__items">
                <i className="icon-shopping_cart" />
                {+this.props.itemCount > 0 && (
                  <span className="checkout__cart-pill__items-count">
                    {this.props.itemCount}
                  </span>
                )}
              </span>
            </button>
          )}
        </div>
      )
    }

    render() {
      this.cartPlaceholder = window.parent.document.querySelector('.org-listing__header');

      if (this.cartPlaceholder) {
        return createPortal(
          this.renderContent(),
          this.cartPlaceholder
        );
      }

      return this.renderContent();
    }
}

ContinueCheckoutBanner.propTypes = {
    showCart: PropTypes.func.isRequired,
    amount: PropTypes.number.isRequired
}

export default ContinueCheckoutBanner
